import { Breadcrumb } from '@components/breadcrumb';
import { useFragment } from 'react-relay';
import { TypeMap, fundsListPageFragment } from './lib';
import type { FundsListPageProps } from './types';

export const FundsListPage: React.FC<FundsListPageProps> = (props) => {
  const page = useFragment(fundsListPageFragment, props.page);

  return (
    <div>
      <Breadcrumb data={page.breadcrumbs} />
      <div className="Base-container">
        {page.components?.edges?.map((edge, index) => {
          if (!edge?.node) {
            return null;
          }
          const Type = TypeMap[edge.node.__typename];
          return (
            <Type
              key={page.id}
              path={page.id}
              component={edge.node}
              location={props.location}
              currentLanguage={props.currentLanguage.split('-')[0]}
              salesAdmission={props.salesAdmission}
              onChangeSalesAdmission={props.onChangeSalesAdmission}
            />
          );
        })}
      </div>
    </div>
  );
};
